export default __webpack_public_path__ + "static/media/profilePic.30b49611.png";